
type Props = {
    nameId: string,
    className: string;
    onChange: () => void;
    pharmacies?: {num: number}[];

  };

const FormSelect = (props: Props) => {
  return (
    <select
        id={props.nameId}
        name={props.nameId}
        className={props.className}
        required
        onChange={props.onChange}
    >
        {
        props.pharmacies?.map((ph) => (
            <option defaultValue={ph.num} key={ph.num}>
            {ph.num}
            </option>
        ))}
    </select>
  )
}

export default FormSelect
